import React from 'react';
import ScrollNav from './../../ScrollNav';


import {
    NavLink,
    Link
} from 'react-router-dom'

class List extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {category} = this.props.match.params;
        let projects = this.props.projects && Object.keys(this.props.projects.data).length ? this.props.projects.data[category] : [] ;
        if(!projects.length) return  <section className="section" />;
        let projectsHtml = projects.length && projects.map((item, key) => {
            return (
                <section className="section" key={key}>
                    <figure>
                        <img className="fullScreen" src={item.hero_image.url}  alt={item.post_title} title={item.post_title} />
                        <Link to={`${process.env.PUBLIC_URL}/project/${item.post_name}`} className="page-link" >
                            <div className="main-container">
                                <div>
                                    <h5 className="title-xl">{item.post_title}</h5>
                                </div>
                                <div>
                                    <div className="title-sm" dangerouslySetInnerHTML={{__html:item.post_excerpt}} />
                                    <span className="btn-arw right">Read More</span>
                                </div>
                            </div>
                        </Link>
                    </figure>
                    <ScrollNav/>
                </section>
            )
        })
        return projectsHtml;
    }
}

export default List;


// WEBPACK FOOTER //
// ./src/components/Projects/Category/List.js